export default (location, params, matchpath) => {
  const match = {
    params,
    path: matchpath,
    url: location.pathname,
  };

  return match;
};
